












































import { Component, Vue } from "vue-property-decorator";
import CustomLabel from "@/components/label.vue";
import VersionApi from "@/api/admin/version";
import { KeyValueModel, PaginationModel, VersionModel } from "@/api/types";

@Component({
  components: {
    CustomLabel,
  },
})
export default class Version extends Vue {
  data: VersionModel = {
    iosVersion: "0.0.0",
    aosVersion: "0.0.0",
    iosRequire: false,
    aosRequire: false,
  };
  newVersion = "";
  visible = false;
  modalLoading = false;
  aosMode = true;

  mounted() {
    this.load();
  }

  async load() {
    localStorage.removeItem("auth");
    const result = await VersionApi.single();
    this.data = result;
  }

  async showModal(isAndroid: boolean) {
    this.aosMode = isAndroid ? true : false;
    this.newVersion = isAndroid ? this.data.aosVersion! : this.data.iosVersion!;
    this.visible = true;
  }

  async onAosChange(checked: boolean, _: Event) {
    this.data.aosRequire = checked;
    await VersionApi.update({
      key: "aosRequire",
      value: this.data.aosRequire ? "0" : "1",
    });
  }

  async onIosChange(checked: boolean, _: Event) {
    this.data.iosRequire = checked;
    await VersionApi.update({
      key: "iosRequire",
      value: this.data.iosRequire ? "0" : "1",
    });
  }

  async handleOk() {
    this.modalLoading = true;
    await VersionApi.update({
      key: this.aosMode ? "aosVersion" : "iosVersion",
      value: this.newVersion,
    });
    this.modalLoading = false;
    this.visible = false;
    this.load();
  }

  handleCancel() {
    this.visible = false;
  }
}
